/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2022-12-05 11:07:02
 * @LastEditTime: 2022-12-06 11:41:13
 * @LastEditors: 赵大壮
 */
import config from '../nyConfig'
const ApiOrder = {
    "订单列表": new config({ url: '/order/listOrder', showSuccessMessage: false, useToken: true }),
    "预约咨询详情": new config({ url: '/order/infoSubscribe', showSuccessMessage: false, useToken: true }),
    "测评用户信息": new config({ url: '/order/infoAssess', showSuccessMessage: false, useToken: true }),
    "查看报告": new config({ url: '/order/showReport', showSuccessMessage: false, useToken: true }),
    "预约用户列表": new config({ url: '/order/listSubscribe', showSuccessMessage: false, useToken: true }),
    "导出预约用户": new config({ url: '/order/exportSubscribe', showSuccessMessage: false, useToken: true }),
    "用户测评列表": new config({ url: '/order/listAssess', showSuccessMessage: false, useToken: true }),
    "导出测评列表": new config({ url: '/order/exportAssess', showSuccessMessage: false, useToken: true }),
    "处理预约记录": new config({ url: '/order/doHandler', showSuccessMessage: false, useToken: true }),
}

export default ApiOrder